import { values } from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

// Components
import ModalActiveTeamPlan from 'app/views/components/Modals/Info/ModalActiveTeamPlan'
import ModalDefaultPlan from 'app/views/components/Modals/Info/ModalDefaultPlan'
import ModalSendReminders from 'app/views/components/Modals/Info/ModalSendReminders'
import OrganizationLayout from 'app/views/containers/Organizations/components/Layout'

// Redux
import {
  deletePlanById,
  getPlans,
  getPlanById,
  updatePlanById,
} from 'app/state/modules/plan'

// Utils
import analytics from 'app/views/utils/analytics'


class OrganizationsPlansEdit extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      error: '',
      deleteError: '',
      title: '',
      description: '',
      defaultPlan: false,
      sendReminders: false,
      confirmDelete: false,
      planType: 'date',
    }

    this.handleChangeTitle = this.handleChangeTitle.bind(this)
    this.handleChangeDescription = this.handleChangeDescription.bind(this)
    this.handleChangeDefaultPlan = this.handleChangeDefaultPlan.bind(this)
    this.handleChangeSendReminders = this.handleChangeSendReminders.bind(this)
    this.handleSubmitSave = this.handleSubmitSave.bind(this)
    this.handleDeleteClick = this.handleDeleteClick.bind(this)
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this)
    this.handleDeleteCancel = this.handleDeleteCancel.bind(this)
    this.handleChangePlanType = this.handleChangePlanType.bind(this)
  }

  componentDidMount() {
    this.props.getPlanById(
      this.props.match.params.organization_uuid,
      this.props.match.params.plan_uuid,
    )
    if (
      this.props.match.params.plan_uuid in this.props.planMap
      && this.props.planMap[this.props.match.params.plan_uuid].uuid !== null
    ) {
      this.setState({
        uuid: this.props.planMap[this.props.match.params.plan_uuid].uuid,
        title: this.props.planMap[this.props.match.params.plan_uuid].title,
        description: this.props.planMap[this.props.match.params.plan_uuid].description,
        defaultPlan: this.props.planMap[this.props.match.params.plan_uuid].default_plan,
        sendReminders: this.props.planMap[this.props.match.params.plan_uuid].send_reminders,
        planType: this.props.planMap[this.props.match.params.plan_uuid] && this.props.planMap[this.props.match.params.plan_uuid].is_time_based ? 'time' : 'date',
        teamUUID: this.props.planMap[this.props.match.params.plan_uuid].team_uuid,
      })
    }

    analytics.page('page-organizations-plans-edit')
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      ((!(this.props.match.params.plan_uuid in this.props.planMap)
        && this.props.match.params.plan_uuid in nextProps.planMap)
        || (this.props.match.params.plan_uuid in this.props.planMap
          && this.props.match.params.plan_uuid in nextProps.planMap
          && this.props.planMap[this.props.match.params.plan_uuid].uuid
          !== nextProps.planMap[this.props.match.params.plan_uuid].uuid))
    ) {
      this.setState({
        uuid: nextProps.planMap[this.props.match.params.plan_uuid].uuid,
        title: nextProps.planMap[this.props.match.params.plan_uuid].title,
        description: nextProps.planMap[this.props.match.params.plan_uuid].description,
        defaultPlan: nextProps.planMap[this.props.match.params.plan_uuid].default_plan,
        sendReminders: nextProps.planMap[this.props.match.params.plan_uuid].send_reminders,
        planType: nextProps.planMap[this.props.match.params.plan_uuid] && nextProps.planMap[this.props.match.params.plan_uuid].is_time_based ? 'time' : 'date',
        teamUUID: nextProps.planMap[this.props.match.params.plan_uuid].team_uuid,
      })
    }

    if (nextProps !== this.props.deletingPlanByIdError) {
      this.setState({ deleteError: nextProps.deletingPlanByIdError })
    }
  }

  handleChangeTitle(e) {
    this.setState({ title: e.target.value })
  }

  handleChangeDescription(e) {
    this.setState({ description: e.target.value })
  }

  handleChangeDefaultPlan(e) {
    this.setState({ defaultPlan: e.target.checked })
  }

  handleChangePlanType(e) {
    this.setState({ planType: e.target.name })
  }

  handleChangeSendReminders(e) {
    this.setState({ sendReminders: e.target.checked })
  }

  handleSubmitSave(event) {
    event.preventDefault()

    if (this.state.title === '') {
      this.setState({ error: 'Title is required.' })
    } else {
      this.props
        .updatePlanById(
          this.props.match.params.organization_uuid,
          this.props.match.params.plan_uuid,
          this.state.title,
          this.state.description,
          this.state.defaultPlan,
          this.state.sendReminders,
          this.state.teamUUID,
        )
        .then(() => {
          if (this.state.teamUUID) {
            this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/teams/${this.state.teamUUID}/plans`)
          } else {
            this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/plans`)
          }
        })
    }
  }

  handleDeleteClick(e) {
    e.preventDefault()

    this.setState({ confirmDelete: true, deleteError: '' })
  }

  handleDeleteConfirm(e) {
    e.preventDefault()

    this.props
      .deletePlanById(this.props.match.params.organization_uuid, this.props.match.params.plan_uuid)
      .then((success) => {
        if (success === true) {
          this.setState({ confirmDelete: false })
          this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/plans`)
        }
      })
  }

  handleDeleteCancel(e) {
    e.preventDefault()

    this.setState({ confirmDelete: false })
  }

  render() {
    return (
      <OrganizationLayout {...this.props} active="plans">
        {this.state.confirmDelete === false ? (
          <>
            <h1>{this.state.teamUUID ? 'Edit Team Training Plan' : 'Edit Training Plan'}</h1>
            <div className="uk-card uk-card-default uk-card-body">
              <div className="uk-container-small">
                <form className="uk-form-stacked">
                  <div className="uk-margin">
                    <label className="uk-form-label">Title</label>
                    <div className="uk-form-controls">
                      <input
                        className="uk-input"
                        type="text"
                        placeholder=""
                        value={this.state.title}
                        onChange={this.handleChangeTitle}
                      />
                    </div>
                  </div>

                  <div className="uk-margin">
                    <label className="uk-form-label">Description</label>
                    <div className="uk-form-controls">
                      <input
                        className="uk-input"
                        type="text"
                        placeholder=""
                        value={this.state.description}
                        onChange={this.handleChangeDescription}
                      />
                    </div>
                  </div>
                  <div className="uk-margin uk-grid-small uk-child-width-auto uk-grid">
                    <label>
                      <input disabled onChange={this.handleChangePlanType} className="uk-radio" type="radio" name="date" checked={this.state.planType === 'date'} />
                      {' Date based'}
                    </label>
                    <label>
                      <input disabled onChange={this.handleChangePlanType} className="uk-radio" type="radio" name="time" checked={this.state.planType === 'time'} />
                      {' Time based'}
                    </label>

                    {/* <a
                      href="#"
                      data-uk-icon="icon: info; ratio: 0.8"
                      data-uk-toggle="target: #modal-plan-type"
                      style={{ marginLeft: 8 }}
                    /> */}
                  </div>

                  <div className="uk-margin">
                    <div className="uk-form-controls">
                      <input
                        className="uk-checkbox"
                        type="checkbox"
                        checked={this.state.defaultPlan}
                        onChange={this.handleChangeDefaultPlan}
                        style={{ marginRight: 10 }}
                      />
                      {this.state.teamUUID ? (
                        <>
                          Make Active
                          <a
                            href="#"
                            data-uk-icon="icon: info; ratio: 0.8"
                            data-uk-toggle="target: #modal-info-active-team-plan"
                            style={{ marginLeft: 8 }}
                          />
                          <ModalActiveTeamPlan />
                        </>
                      ) : (
                        <>
                          Default Plan
                          <a
                            href="#"
                            data-uk-icon="icon: info; ratio: 0.8"
                            data-uk-toggle="target: #modal-info-default-plan"
                            style={{ marginLeft: 8 }}
                          />
                          <ModalDefaultPlan />
                        </>
                      )}
                    </div>
                  </div>
                  <div id="modal-default-plan" data-uk-modal>
                    <div className="uk-modal-dialog uk-modal-body">
                      {this.state.teamUUID ? (
                        <ModalActiveTeamPlan />
                      ) : (
                        <ModalDefaultPlan />
                      )}
                      <p className="uk-text-right">
                        <button
                          className="uk-button uk-button-primary uk-modal-close"
                          type="button"
                        >
                          Ok
                        </button>
                      </p>
                      <button className="uk-modal-close-outside" type="button" data-uk-close />
                    </div>
                  </div>

                  <div className="uk-margin">
                    <div className="uk-form-controls">
                      <input
                        className="uk-checkbox"
                        type="checkbox"
                        checked={this.state.sendReminders}
                        onChange={this.handleChangeSendReminders}
                        style={{ marginRight: 10 }}
                      />
                      Send Reminders
                      <a
                        href="#"
                        data-uk-icon="icon: info; ratio: 0.8"
                        data-uk-toggle="target: #modal-info-send-reminders"
                        style={{ marginLeft: 8 }}
                      />
                      <ModalSendReminders />
                    </div>
                  </div>

                  {this.state.error !== '' && (
                    <div className="uk-margin">
                      <p className="uk-text-danger">{this.state.error}</p>
                    </div>
                  )}

                  <div className="uk-margin">
                    <div className="uk-form-controls">
                      <button
                        type="button"
                        className="uk-button uk-button-primary tm-button-default"
                        onClick={this.handleSubmitSave}
                      >
                        Save Changes
                      </button>
                      <a data-test-id="delete-plan-btn" href="#" style={{ marginLeft: 10 }} onClick={this.handleDeleteClick}>
                        Delete Training Plan
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </>
        ) : (
            <>
              <h1>Delete Training Plan</h1>
              <div className="uk-card uk-card-default uk-card-body" data-test-id="delete-confirm-container">
                <div className="uk-container-small">
                  <p>
                    Are you sure you want to delete the training plan "
{this.state.title}
                    "?
                </p>
                  <form className="uk-form-stacked">
                    {this.state.deleteError !== '' && (
                      <div className="uk-margin">
                        <p className="uk-text-danger">{this.state.deleteError}</p>
                      </div>
                    )}
                    <div className="uk-margin">
                      <div className="uk-form-controls">
                        <button
                          type="button"
                          className="uk-button uk-button-danger tm-button-default"
                          onClick={this.handleDeleteConfirm}
                          data-test-id="confirm-delete-plan-btn"
                        >
                          Delete
                        </button>
                        <button
                          type="button"
                          className="uk-button uk-button tm-button-default"
                          onClick={this.handleDeleteCancel}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </>
          )
        }
      </OrganizationLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  // content
  courses: state.content.courses,
  lessonMap: state.content.lessonMap,
  tests: state.content.tests,

  // hacker
  organizations: values(state.hacker.organizationsList),
  organizationsHash: state.hacker.organizationsHash,
  // plans
  planMap: state.plan.planMap,
  deletingPlanByIdError: state.plan.deletingPlanByIdError,

  // user
  email: state.auth.user.email,
})
const mapDispatchToProps = (dispatch) => ({
  updatePlanById: (
    organizationId,
    planId,
    title,
    description,
    defaultPlan,
    sendReminders,
    teamUUID,
  ) => dispatch(
    updatePlanById(
      organizationId,
      planId,
      title,
      description,
      defaultPlan,
      sendReminders,
      teamUUID,
    ),
  ),
  deletePlanById: (organizationId, planId) => dispatch(deletePlanById(organizationId, planId)),
  getPlanById: (organizationId, planId) => dispatch(getPlanById(organizationId, planId)),
  getPlans: (organizationUUID) => dispatch(getPlans(organizationUUID)),
})
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(OrganizationsPlansEdit),
)
